"use strict";

var moment = require('moment');
require('moment-range');
var i18n = require('ofs/i18n');
var settings = require('ofs/settings');

// Import all the moment languages we support
require('moment/locale/fr');
require('moment/locale/en-gb'); // English goes last because it's the default

moment.locale(settings.LANGUAGE);

var strftimeFormats = {};
var phpFormats = {};

var translateStrftimeToMoment = function(item) {
  if (item.substring(0, 2) === "%%") {
    return item.replace("%%", "%");
  }

  switch (item) {
    case "%a":
      return "ddd";
    case "%A":
      return "dddd";
    case "%h":
    case "%b":
      return "MMM";
    case "%B":
      return "MMMM";
    case "%c":
      return "LLLL";
    case "%d":
      return "D";
    case "%j":
      return "DDDD";
    case "%e":
      return "Do";
    case "%m":
      return "MM";
    case "%p":
      return "A";
    case "%P":
      return "a";
    case "%S":
      return "ss";
    case "%M":
      return "mm";
    case "%H":
      return "HH";
    case "%I":
      return "hh";
    case "%w":
      return "d";
    case "%W":
    case "%U":
      return "ww";
    case "%x":
      return "LL";
    case "%X":
      return "LT";
    case "%g":
    case "%y":
      return "YY";
    case "%G":
    case "%Y":
      return "YYYY";
    case "%z":
      return "ZZ";
    case "%Z":
      return "z";
    case "%f":
      return "SSS";
    default:
      return item;
  }
};

var translatePhpFormat = function(item) {
  if (item.charAt(0) === "\\") {
    return item.replace("\\", "");
  }

  switch (item) {
    case "D":
      return "ddd";
    case "l":
      return "dddd";
    case "M":
      return "MMM";
    case "F":
      return "MMMM";
    case "j":
      return "D";
    case "m":
      return "MM";
    case "A":
      return "A";
    case "a":
      return "a";
    case "s":
      return "ss";
    case "i":
      return "mm";
    case "H":
      return "HH";
    case "g":
      return "h";
    case "h":
      return "hh";
    case "w":
      return "d";
    case "W":
      return "ww";
    case "y":
      return "YY";
    case "o":
    case "Y":
      return "YYYY";
    case "O":
      return "ZZ";
    case "z":
      return "DDD";
    case "d":
      return "DD";
    case "n":
      return "M";
    case "G":
      return "H";
    case "e":
      return "zz";
    case "N":
      return "MMMM";
    default:
      return item;
  }
};

moment.fn.strftime = function(format) {
  if (!strftimeFormats[format]) {
    strftimeFormats[format] = format.replace(/%?.|%%/g, translateStrftimeToMoment);
  }
  return this.format(strftimeFormats[format]);
};

moment.fn.phpFormat = function(format) {
  if (!phpFormats[format]) {
    phpFormats[format] = format.replace(/\\?./g, translatePhpFormat);
  }
  return this.format(phpFormats[format]);
};

moment.fn.shortDateFormat = function() {
  return this.phpFormat(i18n.get_format('SHORT_DATE_FORMAT'));
};

moment.fn.longDateFormat = function() {
  return this.phpFormat(i18n.get_format('DATE_FORMAT'));
};

moment.fn.isoDateFormat = function() {
  return this.format('YYYY-MM-DD');
};

module.exports = moment;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/moment.js
 **/